import { stepUpdated } from '../../../../redux/questionnaire/questionnaire.slice';
import { ErrorSource, QuestionnaireFlow } from '../../../../redux/questionnaire/typings';
import { ButtonType } from '../../../../redux/ui/typings';
import { t } from '../../../../strings/i18n/i18n';
import createCase from '../../../../redux/cases/createCase';
import { closeModalHelper } from './closeHandlers';
export var errorButtonText = function (buttonType, _a) {
    var source = _a.source, count = _a.count;
    switch (buttonType) {
        case ButtonType.Primary: {
            var hasAttemptsLeft = source === ErrorSource.PostCases && count < 3;
            return {
                text: hasAttemptsLeft ? t('button.tryAgain') : t('button.ok'),
                dataReason: hasAttemptsLeft ? 'Try-again' : 'Ok'
            };
        }
        case ButtonType.Secondary:
            return { text: t('button.back'), dataReason: 'Back' };
        default:
            return { text: '', dataReason: '' };
    }
};
export var errorButtonHandler = function (buttonType, _a) {
    var source = _a.source, count = _a.count;
    return function (dispatch) {
        switch (buttonType) {
            case ButtonType.Primary:
                if (source === ErrorSource.PostCases && count < 3) {
                    return dispatch(createCase());
                }
                return dispatch(closeModalHelper());
            case ButtonType.Secondary:
                return source === ErrorSource.PostCases && count < 3
                    ? dispatch(stepUpdated(QuestionnaireFlow.Review))
                    : dispatch(stepUpdated(QuestionnaireFlow.Start));
            default:
                return null;
        }
    };
};
//# sourceMappingURL=errorHandlers.js.map